import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchAccount = ({ include, accountId }) =>
  HttpClient().get(`/accounts/v2/${accountId}`, {
    params: { include },
  })

const getAccount = (params) => (dispatch) =>
  fetchAccount(params)
    .then((response) => dispatch(loadJsonApiEntities(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getAccount
